module.exports = require("@platform/front-utils");